import React from 'react'

import Orders from "../../Components/Orders";
import {useCity} from "../../CityContext";

export default function Public() {
  const {selectedCityIds} = useCity();

  return (
    <Orders cityIds={selectedCityIds}/>
  )
}
